import Fade from "react-reveal/Fade";
import HorizontalScrollCarousel from "./HorizontalScrollCarousel";
import Collabs from "./collabs";

export const ShowCase = () => {
  return (
    <section className="w-[100%] rounded-xl md:px-0 px-4 pt-5 md:pt-0">
      <div className="grid lg:grid-cols-2 gap-5 px-4 py-12 border-b-2 rounded-t-xl bg-white text-black  ">
        <div className="rounded-t-xl">
          <Fade top cascade>
            <div className="grid xxl:grid-cols-2 md:px-8 py-12 gap-5  ">
              <div className="md:text-4xl text-2xl font-extrabold ">
                Collaborations
              </div>
              <div className="text-gray-500 ">
                There are certain brands that will always be a tried and true
                classic. A timeless go-to staple that will never go out of style
                and will likely be in everyone’s closet at some point in their
                lives. Converse continues to remain one of those brands.
                Established in 1908, Converse shoes have become known for their
                simple yet eye-catching designs and have joined a select group
                of sneaker brands that have become a fan favorite amongst
                celebrities, influencers, and public figures. Naturally, their
                popularity has transcended over the decades, leading to many
                different groundbreaking partnerships and some of the best
                Converse collabs of all time.
              </div>
            </div>
          </Fade>
        </div>
        <div className="  lg:border-s border-stone-300">
          <Fade top cascade>
            <div className="  grid xxl:grid-cols-2 md:px-8 py-12 gap-5  ">
            <div className="md:text-4xl text-2xl font-extrabold ">
                Let's hit the roads..
              </div>
              <div className="  w-full  text-gray-500 ">
                Today we will be revisiting these collaborations. Warning: some
                of these partnerships were highly sought after and are either no
                longer available for purchase, or much more expensive than their
                original price. On the flip side, you can still find some of
                these shoes via the retail market if you do your digging. Now we
                have that out of the way, let’s take a look back at 20 of
                Converse’s best collabs.
              </div>
            </div>
          </Fade>
        </div>
      </div>
      
        <div className="w-full ">
          <HorizontalScrollCarousel/>
          <Collabs />
        </div>
    
    </section>
  );
};
